module.exports = __webpack_public_path__ + "img/DAB-Profile-Prashant.cb6c2ba6.png";